import { render } from "./Login.vue?vue&type=template&id=70a029cb&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=70a029cb&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a029cb"]])

export default __exports__